import React from "react";
import HeaderMenue from "./HeaderMenue";
import SideMenue from "./SideMenue";
import PageLoader from "../common/PageLoader";
import BreadCrumbMenue from "./BreadCrumbMenue";
import { Toast } from "primereact/toast";

const Layout = ({ title, loading, toast, children }) => {

  const [pageLoader, setPageLoader] = React.useState(false);

  const [breadCrumb, setBreachCrumb] = React.useState([]);

  const [visible, setVisible] = React.useState(false);

  const toastL = React.useRef(toast);

  if (pageLoader) return <PageLoader title={title} />;

  return (
    <div  style={{ height: "97vh" }}>
    <Toast ref={toastL} />
      <SideMenue selectedTitle={title} setBreachCrumb={setBreachCrumb} setPageLoader={setPageLoader} setVisible={setVisible} isVisible={visible} />
      <div>
        <HeaderMenue title={title} setBreachCrumb={setBreachCrumb} loading={loading} setVisible={setVisible} setPageLoader={setPageLoader} />
        <BreadCrumbMenue title={title} breadCrumb={breadCrumb} setPageLoader={setPageLoader} />
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Layout;
